import { SystemEmailRegistryEntry } from "../../../services/admin/systemEmails.service";
import { SystemEmailRegistryDetailCells } from "./SystemEmailRegistryDetailCells";
import { SystemEmailRegistryPrimaryCell } from "./SystemEmailRegistryPrimaryCell";

export function SystemEmailRegistryIdentityCells({
  entry,
}: {
  entry: SystemEmailRegistryEntry;
}) {
  return (
    <>
      <SystemEmailRegistryPrimaryCell entry={entry} />
      <SystemEmailRegistryDetailCells entry={entry} />
    </>
  );
}
